import Vue from 'vue';
import vuex, {Store} from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import * as stores from './modules';
import navigation from '@/navigation/store/navigation';
import projectOne from '@/projectOne/store/project-one';
import preSeason from '@/preSeason/store/pre-season';
import bontragerCustom from '@/bontragerCustom/store/bontrager-custom-store';

Vue.use(vuex);

const localACC = window.ACC || {};
const languageISO = localACC.languageISO || 'en';
const unitId = window.ACC.currentB2BUnit ? window.ACC.currentB2BUnit : 'b2c';

export default new Store({
  state: {
    locale: window.ACC.languageISO || null,
    unitId: unitId,
    vvLocale: languageISO.split('_')[0] || 'en',
  },

  getters: {
    unitId(state) {
      return state.unitId;
    },
  },

  mutations: {
    setState(state, payload) {
      Object.keys(payload).forEach((key) => {
        let value = payload[key];
        Vue.set(state, key, value);
      });
    },
    setUnitId(state, value) {
      if (value.length) {
        Vue.set(state, 'unitId', value);
      } else {
        Vue.set(state, 'unitId', 'b2c');
      }
    },
  },

  actions: {
    setUserData({commit}, {unitId}) {
      commit('addRack', unitId);
    },
  },

  modules: {
    ...stores,
    navigation,
    projectOne,
    preSeason,
    bontragerCustom,
  },

  plugins: [
    createPersistedState({
      paths: ['storage', 'compare', 'storeLocator', 'preSeason.successOnOverview'],
    }),
  ],
});
